import { ProspectType, ProspectTypeFilter } from "../types/onboarding";

/**
 * CWA-184: an onboarding is a new customer or another station of an existing one (CWA-179). The backend sets the
 * type; a prospect from an older backend has none and is a new customer.
 */
export const prospectTypeOf = (p: {
  prospect_type?: ProspectType | null;
}): ProspectType => p.prospect_type ?? "NEW_CUSTOMER";

export const isAdditionalStation = (p: {
  prospect_type?: ProspectType | null;
}): boolean => prospectTypeOf(p) === "ADDITIONAL_STATION";

/** Pipeline list filter: null shows every onboarding. */
export const PROSPECT_TYPE_OPTIONS: { label: string; value: ProspectType | null }[] =
  [
    { label: "All onboardings", value: null },
    { label: "New customers", value: "NEW_CUSTOMER" },
    { label: "Additional stations", value: "ADDITIONAL_STATION" },
  ];

export const ANALYTICS_TYPE_OPTIONS: { label: string; value: ProspectTypeFilter }[] =
  [
    { label: "New customers", value: "NEW_CUSTOMER" },
    { label: "Additional stations", value: "ADDITIONAL_STATION" },
    { label: "All onboardings", value: "ALL" },
  ];
